<template>
  <div class="container">
    <h2>Did you mean?</h2>
    <ul>
      <ResultItem
        v-for="result in results"
        v-bind:key="result.slug"
        v-bind:result="result" />
    </ul>
    <small>Search Results &copy; <a href='https://www.mapbox.com/about/maps/'>Mapbox</a></small>
  </div>
</template>

<script>
import router from "@/router/index";
import { didYouMean } from "@/services/mapbox";
import ResultItem from "@/components/SearchResults/ResultItem";

export default {
  components: { ResultItem },
  props: ["query"],
  data() {
    return {
      results: []
    };
  },
  created() {
    didYouMean(this.query).then((results) => {
      if (results.length === 1) {
        return router.push({
          name: "Address",
          params: { geohash: results[0].geohash, slug: results[0].slug }
        });
      }
      this.results = results;
    });
  },
  destroyed() {
    this.$store.dispatch("clearMarkers");
  },
  watch: {
    results(newResults) {
      this.$store.dispatch("showSearchResults", newResults);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/SearchResults.vue